import { isNumber } from "@suse-o11y/is-number";
import { isString } from "@suse-o11y/is-string";

import type { HeightSpec } from "./calculate-auto-height";

export function getHeightProp(
	height: HeightSpec | number | "auto" | (string & {}),
): [undefined | number | string, undefined | "auto" | HeightSpec] {
	if (height === "auto") {
		return ["auto", "auto"];
	}

	if (isNumber(height) || isString(height)) {
		return [height, undefined];
	}

	return ["auto", height];
}
